module.exports = __webpack_public_path__ + "static/img/9.0468cba8.png";